// extracted by css-extract-rspack-plugin
var _1 = "actions-nTQczh";
var _2 = "description-ARlPAc";
var _3 = "tip-JtcQT1";
export { _1 as "actions", _2 as "description", _3 as "tip" }
